import { render, staticRenderFns } from "./BasicPageToptree_Markets.vue?vue&type=template&id=4194b11d&scoped=true&"
import script from "./BasicPageToptree_Markets.vue?vue&type=script&lang=js&"
export * from "./BasicPageToptree_Markets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4194b11d",
  null
  
)

export default component.exports